<script>
	import ButtonInput from '../atoms/ButtonInput.svelte';
	import Image from '../atoms/Image.svelte';
	import AlternateButton from './AlternateButton.svelte';
	import MediaForm from './MediaForm.svelte';
	import { SendDataToPhp } from '../service';
	import { getPhpFolderPath, getConnectorValue } from '../query';
	import ImageLink from '../atoms/ImageLink.svelte';

	export let maxValue;
	export let media;
	export let route;
	let newPos = media.position;
	let isConnected = getConnectorValue();
	$: position = media.landscapeMode === '1' ? 'landscape' : 'portrait';

	function deletePortfolio() {
		SendDataToPhp(getPhpFolderPath() + 'delElem.php', 'pos=' + media.position + '&table=media', 'protfolio');
	}

	function up() {
		SendDataToPhp(getPhpFolderPath() + 'up.php', 'table=media&id=' + media.id + '&pos=' + media.position, 'protfolio');
	}
	function down() {
		SendDataToPhp(getPhpFolderPath() + 'down.php', 'table=media&id=' + media.id + '&pos=' + media.position, 'protfolio');
	}

	function changePos() {
		position = media.position;
		if (newPos < 1) {
			alert('La position ne peut pas être inférieur à 1');
			newPos = position;
		}
		SendDataToPhp(
			getPhpFolderPath() + 'ChangePos.php',
			'table=media&initPos=' + media.position + '&id=' + media.id + '&pos=' + newPos,
			'protfolio'
		);
		newPos = position;
	}

	function editAccueil() {
		SendDataToPhp(
			getPhpFolderPath() + 'ChangeAccueil.php',
			'table=media&id=' + media.id + '&accueil=' + !media.accueil,
			'protfolio'
		);
	}
</script>

{#if maxValue > -1}
	<article class={position}>
		{#if isConnected}
			<div>
				<div>
					<AlternateButton condition={media.position != 1} onClick={up} value="Up" />
					<AlternateButton condition={media.position != maxValue} onClick={down} value="Down" />
				</div>
				{#if media.accueil}
					<ButtonInput value="Retirer de l'accueil" onClick={editAccueil} />
				{:else}
					<ButtonInput value="Ajouter à l'accueil" onClick={editAccueil} />
				{/if}
				<!--<MediaForm onClick={changePos} bind:positionValue={newPos} {maxValue} />-->
				<ButtonInput value="Supprimer" onClick={deletePortfolio} />
			</div>
		{/if}
		<Image src={media.pathMedia} alt={media.pathMedia} />
	</article>
{:else if media.landscapeMode === undefined}
	<ImageLink src={media.pathMedia} alt={media.pathMedia} {route} />
{:else}
	<div class="{position} accueil">
		<ImageLink src={media.pathMedia} alt={media.pathMedia} {route} />
	</div>
{/if}

<style>
	.accueil {
		margin: 1%;
	}

	.landscape {
		width: 75%;
	}

	.landscape > div {
		width: 74%;
	}

	.portrait {
		width: 36.5%;
	}

	.portrait > div {
		width: 35.5%;
	}

	article {
		margin: 1%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	article > div {
		display: flex;
		justify-content: space-between;
		padding: 0% 0.5%;
		background-color: rgba(157, 138, 186, 0.5);
		position: absolute;
	}
</style>
